import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
  Renderer2,
} from "@angular/core";
import $ from "jquery";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { isFirefox, isEdge } from '../../shared/utils/browser.util';
import {
  findIndex,
  each,
  orderBy,
  isNull,
  filter,
  forEach,
  map,
  some,
} from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { PlaybookCommunicationService } from "../shared/services/playbook-communication.service";
import {
  ContentColumn,
  ContentRow,
  Container,
  ContentBlock,
  CopyContentExists,
  ContentBlockAnimation,
  MobilePlaybookRow,
} from "src/app/shared/model/container.models";
import { UtilService } from "../shared/services/utils/util.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import { PlaybookAddRowColumnService } from "../shared/services/playbookAddRowColumn/playbook-add-row-column.service";
import { SessionStorageService } from "src/app/shared/services/session-storage/session-storage.service";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import {
  ContentBlockType,
  DefaultLanguageId,
  Modalconfig,
  PlaybookMobileRow,
} from "src/app/shared/constants";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import { LocalStorageService } from "ngx-webstorage";
@Component({
    selector: "app-content-box",
    templateUrl: "./content-box.component.html",
    styleUrls: ["./content-box.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContentBoxComponent implements OnInit, OnDestroy {
  @Input("contentColumn") column: ContentColumn;
  @Input() row1: ContentRow;
  @Output() updateSectionEvent = new EventEmitter<Container>();
  @Output() tabChange: EventEmitter<any> = new EventEmitter();
  @Output() changeContentRow = new EventEmitter<{
    row: Container;
    isRowChange: boolean;
    isLeftMove?: boolean;
  }>();
  @ViewChild("contentEditor") contentEditor: any;
  @Input("pageTemplateId") pageTemplateId;
  @Input() container: Container;
  @Input() parentSectionId: number;
  @Input() level: number;
  @Input() tElement: any = null;
  @Input() isTabElement = false;
  @Input() currentContentIndex: number;
  @Input() hideContent: boolean;
  @Input() reorderContent: boolean = false;
  defaultLanguageId = DefaultLanguageId;
  savedWidth: Array<any> = [];
  eventSub: boolean;
  editContentBlockId = null;
  editRowId = null;
  isRowBox: boolean = true;
  updateSubsciption: Subscription;
  rowBoxSubsciption: Subscription;
  animationSubs: Subscription;
  languageId: number;
  vBuilderRedirectURl: string;
  currentTabId = null;
  draggableWithDragMoveContent = {
    type: ContentBlockType.MoveContent,
  };
  contentColumns: any;
  currIndex: number;

  start: any;
  pressed: boolean;
  startX: any;
  startWidth: any;
  resizableColumnOption: any;
  playbookId: number;
  confirmationModalRef: BsModalRef;
  isRowMoving = false;
  pageFrom: number;
  isDragDropAllowed = false;
  isCopyPasteContentExist = new CopyContentExists();
  private modalSubscription: Subscription[] = [];
  public isFireFox = isFirefox();
  public isEdge = isEdge();
  isAnimationBoxOpened = false;
  animationState = false;
  dropdownList;
  animationList = ContentBlockAnimation;
  animationType;
  animationDirection;
  selectedContentBlock: ContentBlock;
  isSafari: boolean;
  hiddenContentRowList: ContentRow[] = [];
  inMobileEditor: boolean = false;
  isMobile: boolean = false;
  isShowEditRowWrapperGrey: number = null;

  constructor(
    private commService: PlaybookCommunicationService,
    private commonHttpService: CommonHttpService,
    private playbookAddRowColumnService: PlaybookAddRowColumnService,
    private utilService: UtilService,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
    private renderer: Renderer2,
    private modalService: BsModalService,
    private localSt: LocalStorageService
  ) {
    this.isSafari = window["isSafari"];
  }

  ngOnInit() {
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.vBuilderRedirectURl =
      this.activatedRoute.snapshot.queryParams.r || null;
    this.playbookId = this.activatedRoute.snapshot.params.playbookId;
    this.pageFrom = +this.activatedRoute.snapshot.queryParams.pageFrom || null;
    if (!isNull(this.pageTemplateId)) {
      this.playbookId = null;
    }
    this.localSt.observe("isShowHide").subscribe((hideContent) => {
      if (
        window !== window.parent &&
        window.location == window.parent.location
      ) {
        this.hidePlaybookContent(hideContent);
      }
    });
    // To handle current selected COntentBlock for showing editor icons
    this.updateSubsciption = this.commService
      .getSelectedContentBlockId()
      .subscribe((contentBlockId) => {
        this.editContentBlockId = contentBlockId;
        if (this.editContentBlockId == null) {
          this.selectedContentBlock = this.editContentBlockId;
        }
      });
    this.animationSubs = this.commService
      .getSelectedContentBlock()
      .subscribe((contentBlock) => {
        if (contentBlock) {
          this.showAnimationMenu(contentBlock);
        } else {
          this.selectedContentBlock = contentBlock;
        }
      });
    this.updateSubsciption = this.commService
      .getSelectedRowId()
      .subscribe((rowId: number) => {
        this.editRowId = rowId;
      });
    this.rowBoxSubsciption = this.commService
      .getSelectedRowBox()
      .subscribe((isRowBox: boolean) => {
        this.isRowBox = isRowBox;
      });
  }
  handleDeviceOrderby() {
    if (
      this.column &&
      this.column.contentRows &&
      window !== window.parent &&
      window.location == window.parent.location
    ) {
      this.saveWidth();
      this.divideRow();
    } else {
      this.contentColumnOrderBy();
    }
  }
  contentColumnOrderBy() {
    map(this.column.contentRows, (eachContentRows: ContentRow) => {
      eachContentRows.contentColumns = orderBy(
        eachContentRows.contentColumns,
        "order"
      );
    });
    this.isCopyPasteContentExist = this.commService.getCopyContentExists();
  }

  applyMobileOrderby(contentColumns) {
    forEach(contentColumns, (eachContentColumns) => {
      if (eachContentColumns.mobileOrderBy === null) {
        eachContentColumns.mobileOrderBy = eachContentColumns.order;
      }
      if (eachContentColumns.mobileRow === null) {
        eachContentColumns.mobileRow = 0;
      }
    });
  }

  saveWidth() {
    map(this.column.contentRows, (eachContentRows: ContentRow) => {
      this.applyMobileOrderby(eachContentRows.contentColumns);
      eachContentRows.contentColumns = orderBy(
        eachContentRows.contentColumns,
        ["mobileRow", "mobileOrderBy"],
        ["asc", "asc"]
      );
      forEach(
        eachContentRows.contentColumns,
        (eachContentColumn: ContentColumn) => {
          this.savedWidth.push({
            id: eachContentColumn.id,
            width: eachContentColumn.columnWidth,
          });
        }
      );
    });
  }
  hideContentBox() {
    map(this.column.contentRows, (eachContentRows: ContentRow) => {
      eachContentRows.contentColumns = filter(
        eachContentRows.contentColumns,
        (eachContentColumn: ContentColumn, index) => !eachContentColumn.isHidden
      );
    });
  }

  divideRow() {
    map(this.column.contentRows, (eachContentRows: ContentRow) => {
      if (eachContentRows.contentColumns.length) {
        const rowIndex = findIndex(
          eachContentRows.contentColumns,
          (eachContentColumn: ContentColumn) =>
            eachContentColumn.mobileRow === PlaybookMobileRow.SecondRow
        );
        if (rowIndex !== -1) {
          const firstRow: Array<ContentColumn> = [
            ...this.reCalculateWidth(
              eachContentRows.contentColumns.slice(0, rowIndex)
            ),
          ];
          const secondRow: Array<ContentColumn> = [
            ...this.reCalculateWidth(
              eachContentRows.contentColumns.slice(rowIndex)
            ),
          ];
          eachContentRows.contentColumns = [
            ...this.calculateLeftRightMove(firstRow),
            ...this.calculateLeftRightMove(secondRow),
          ];
        } else {
          let sliceLength: number = 0;
          if (
            eachContentRows.contentColumns[0].mobileRow !==
            PlaybookMobileRow.NotAssigned
          ) {
            sliceLength = eachContentRows.contentColumns.length;
          } else {
            for (
              let index = 0;
              index < eachContentRows.contentColumns.length;
              index++
            ) {
              eachContentRows.contentColumns[index].mobileRow =
                index >= PlaybookMobileRow.DivideLength
                  ? PlaybookMobileRow.SecondRow
                  : PlaybookMobileRow.FirstRow;
            }
            sliceLength = PlaybookMobileRow.DivideLength;
          }
          const firstRow: Array<ContentColumn> = [
            ...this.reCalculateWidth(
              eachContentRows.contentColumns.slice(0, sliceLength)
            ),
          ];
          const secondRow: Array<ContentColumn> = [
            ...this.reCalculateWidth(
              eachContentRows.contentColumns.slice(sliceLength)
            ),
          ];
          eachContentRows.contentColumns = [
            ...this.calculateLeftRightMove(firstRow),
            ...this.calculateLeftRightMove(secondRow),
          ];
        }
      } else if (
        eachContentRows.contentBlock &&
        eachContentRows.contentBlock.id &&
        !eachContentRows.totalButtonWidth
      ) {
        eachContentRows.isLeftMove = false;
        eachContentRows.isRightMove = false;
        eachContentRows.isRowChange = false;
        eachContentRows.totalButtonWidth = "0px";
      }
    });
  }

  calculateLeftRightMove(
    contentColumnArray: Array<ContentColumn>
  ): Array<ContentColumn> {
    if (!contentColumnArray.length) {
      return contentColumnArray;
    }
    if (contentColumnArray.length === 1) {
      this.assignLeftRightMoveWholeRow(
        contentColumnArray[0],
        false,
        false,
        true
      );
    } else {
      // for index 0, any length
      this.assignLeftRightMoveWholeRow(
        contentColumnArray[0],
        false,
        true,
        contentColumnArray[0].mobileRow === PlaybookMobileRow.FirstRow
          ? false
          : true
      );
      // for last index, any length
      this.assignLeftRightMoveWholeRow(
        contentColumnArray[contentColumnArray.length - 1],
        true,
        false,
        contentColumnArray[contentColumnArray.length - 1].mobileRow ===
          PlaybookMobileRow.FirstRow
          ? true
          : false
      );
      // for other indexes,
      for (let index = 1; index < contentColumnArray.length - 1; index++) {
        this.assignLeftRightMoveWholeRow(
          contentColumnArray[index],
          true,
          true,
          false
        );
      }
    }
    return contentColumnArray;
  }

  assignLeftRightMoveWholeRow(
    eachContentColumn: ContentColumn,
    isLeftMove: boolean,
    isRightMove: boolean,
    isRowChange: boolean
  ): ContentColumn {
    forEach(eachContentColumn.contentRows, (eachContentRow) => {
      const calWidth =
        (isLeftMove ? 1 : 0) + (isRightMove ? 1 : 0) + (isRowChange ? 1 : 0);
      switch (calWidth) {
        case 0:
          eachContentRow.totalButtonWidth = "0px";
          break;
        case 1:
          eachContentRow.totalButtonWidth = "35px";
          break;
        case 2:
          eachContentRow.totalButtonWidth = "70px";
          break;
        case 3:
          eachContentRow.totalButtonWidth = "105px";
          break;
        default:
          break;
      }
      eachContentRow.isLeftMove = isLeftMove;
      eachContentRow.isRightMove = isRightMove;
      eachContentRow.isRowChange = isRowChange;
    });
    return eachContentColumn;
  }

  reCalculateWidth(contentColumn: Array<ContentColumn>): Array<ContentColumn> {
    let totalWitdh = 0;
    forEach(contentColumn, (eachContentColumn: ContentColumn) => {
      totalWitdh += eachContentColumn.columnWidth;
    });
    return this.calculateRowWidth(contentColumn, totalWitdh);
  }

  calculateRowWidth(
    contentColumn: Array<ContentColumn>,
    totalWitdh: number
  ): Array<ContentColumn> {
    forEach(contentColumn, (eachContentColumn: ContentColumn) => {
      eachContentColumn.columnWidth = this.calculateWidthPercentage(
        eachContentColumn.columnWidth,
        totalWitdh
      );
    });
    return contentColumn;
  }

  calculateWidthPercentage(
    eachContentColumnWidth: number,
    totalWitdh: number
  ): number {
    const contentWidth = (eachContentColumnWidth * 100) / totalWitdh;
    const truncatedWitdh = Math.trunc(contentWidth);
    if (
      truncatedWitdh % 5 === 0 ||
      truncatedWitdh === 33 ||
      truncatedWitdh === 66
    ) {
      return truncatedWitdh;
    } else {
      const roundedWitdh = Math.round(contentWidth / 5) * 5;
      if (
        roundedWitdh % 5 === 0 ||
        roundedWitdh === 33 ||
        roundedWitdh === 66
      ) {
        return roundedWitdh;
      }
    }
    return contentWidth;
  }

  changeTabFunc(event) {
    this.tabChange.emit(event);
  }

  hidePlaybookContent(hideContent) {
    this.hideContent = hideContent;
  }

  changeRow(row) {
    this.changeContentRow.emit({ row: row, isRowChange: true });
  }
  changeContentDataFunc(rowData) {
    let constContentRowIndex: number;
    let constContentColumnIndex: number;
    some(
      this.column.contentRows,
      (eachContentRows: ContentRow, contentRowIndex: number) => {
        some(
          eachContentRows.contentColumns,
          (eachContentColumn: ContentColumn, contentColumnIndex: number) => {
            if (eachContentColumn.id === rowData.row.contentColumnId) {
              constContentRowIndex = contentRowIndex;
              constContentColumnIndex = contentColumnIndex;
              return true;
            }
          }
        );
      }
    );
    rowData.isRowChange
      ? this.changeContentRowFunc(constContentRowIndex, constContentColumnIndex)
      : this.changeContentOrderFunc(
          constContentRowIndex,
          constContentColumnIndex,
          rowData.isLeftMove,
          rowData.row
        );
  }

  changeContentOrderFunc(
    constContentRowIndex: number,
    constContentColumnIndex: number,
    isLeftMove: boolean,
    row: any
  ) {
    let MobilePlaybookRows: Array<MobilePlaybookRow> =
      JSON.parse(localStorage.getItem("mobilePlaybookRow")) || [];
    if (isLeftMove) {
      this.column.contentRows[constContentRowIndex].contentColumns[
        constContentColumnIndex
      ].mobileOrderBy -= 1;
      this.column.contentRows[constContentRowIndex].contentColumns[
        constContentColumnIndex - 1
      ].mobileOrderBy += 1;
    } else {
      this.column.contentRows[constContentRowIndex].contentColumns[
        constContentColumnIndex + 1
      ].mobileOrderBy -= 1;
      this.column.contentRows[constContentRowIndex].contentColumns[
        constContentColumnIndex
      ].mobileOrderBy += 1;
    }
    map(this.column.contentRows, (eachContentRows: ContentRow) => {
      forEach(
        eachContentRows.contentColumns,
        (eachContentColumn: ContentColumn, index) => {
          MobilePlaybookRows = this.saveChangedOrderContent(
            eachContentColumn,
            MobilePlaybookRows,
            true
          );
        }
      );
    });
    localStorage.setItem(
      "mobilePlaybookRow",
      JSON.stringify(MobilePlaybookRows)
    );
    this.handleDeviceOrderby();
  }

  saveChangedOrderContent(
    contentColumn: ContentColumn,
    MobilePlaybookRows: Array<MobilePlaybookRow>,
    isReOrder: boolean
  ) {
    const mobileRowIndex = findIndex(
      MobilePlaybookRows,
      (eachMobileRows) => eachMobileRows.contentColumnId === contentColumn.id
    );
    if (mobileRowIndex === -1) {
      MobilePlaybookRows.push({
        contentColumnId: contentColumn.id,
        isReOrder,
        mobileOrderBy: contentColumn.mobileOrderBy,
        mobileRow: contentColumn.mobileRow,
      });
    } else {
      MobilePlaybookRows[mobileRowIndex] = {
        contentColumnId: contentColumn.id,
        isReOrder,
        mobileOrderBy: contentColumn.mobileOrderBy,
        mobileRow: contentColumn.mobileRow,
      };
    }
    return [...MobilePlaybookRows];
  }

  changeContentRowFunc(
    constContentRowIndex: number,
    constContentColumnIndex: number
  ) {
    this.column.contentRows[constContentRowIndex].contentColumns[
      constContentColumnIndex
    ].mobileRow =
      this.column.contentRows[constContentRowIndex].contentColumns[
        constContentColumnIndex
      ].mobileRow === PlaybookMobileRow.FirstRow
        ? PlaybookMobileRow.SecondRow
        : PlaybookMobileRow.FirstRow;

    let MobilePlaybookRows: Array<MobilePlaybookRow> =
      JSON.parse(localStorage.getItem("mobilePlaybookRow")) || [];
    map(this.column.contentRows, (eachContentRows: ContentRow) => {
      forEach(
        eachContentRows.contentColumns,
        (eachContentColumn: ContentColumn, index) => {
          eachContentColumn.columnWidth = this.savedWidth[index].width;
          MobilePlaybookRows = this.saveChangedOrderContent(
            eachContentColumn,
            MobilePlaybookRows,
            false
          );
        }
      );
    });
    localStorage.setItem(
      "mobilePlaybookRow",
      JSON.stringify(MobilePlaybookRows)
    );
    this.handleDeviceOrderby();
  }

  changeOrder(row, isLeftMove) {
    this.changeContentRow.emit({ row: row, isRowChange: false, isLeftMove });
  }

  private normalizeNewTextRowContent(row: ContentRow) {
    if (
      row?.contentBlock?.type === ContentBlockType.Text &&
      row.contentBlock.basicTextContent == null
    ) {
      row.contentBlock.basicTextContent = "";
    }
  }

  /**
   * To handle uploading changes of text content
   * @param event ckeditor event
   * @param blockId ContentBlock id
   * @param oldtext Old text for comparing of changes
   */
  onBlur(event, contentBlock: ContentBlock, oldtext: string) {
    $(".text-editor-menu-bar").hide();
    const updatedValue = event.editor.getData().trim();
    if (
      contentBlock.shadeUpdate ||
      oldtext == null ||
      oldtext.localeCompare(updatedValue) !== 0
    ) {
      const newLink = this.updateLinksInHTML(updatedValue);
      contentBlock.shadeUpdate = false;
      const reqObj = {
        id: contentBlock.id,
        playbookId: contentBlock.playbookId,
        basicTextContent: newLink,
        shaded: contentBlock.shaded,
        languageId: this.languageId,
        pageTemplateId: this.pageTemplateId,
      };
      this.commService.setServerProcess(true);

      this.commService.setUpdatingTextBlock(true);
      this.commonHttpService
        .putWithHeaders(
          {
            uri: "/api/ContentBlocks/UpdateContentBlock",
            object: reqObj,
          },
          {
            pageId: this.container.id,
            sectionId: this.parentSectionId,
            playbookId: this.playbookId,
            languageId: this.languageId,
            isdraftmode: this.container.isCurrentPageInDraftMode,
          }
        )
        .subscribe(
          (res) => {
            contentBlock.basicTextContent = updatedValue;
            this.commService.setServerProcess(false);

            this.commService.setUpdatingTextBlock(false);
          },
          (error) => this.commService.setServerProcess(false)
        );
    }
  }

  updateLinksInHTML(text) {
    return this.replaceAllFunc(
      text,
      `<a href="${window.location.origin}/playbookeditor`,
      `<a href="${window.location.origin}/playbook`
    );
  }

  disableDragDrop(isDragDropAllowed: boolean) {
    if (this.selectedContentBlock) {
      this.commService.sendSelectedContentBlock(null);
    }
    this.isDragDropAllowed = isDragDropAllowed;
  }

  replaceAllFunc(strings, search, replace) {
    return strings.split(search).join(replace);
  }

  showContentRow(row: ContentRow) {
    row.isHidden = true;
    try {
      this.hiddenContentRowList =
        JSON.parse(localStorage.getItem("hiddenContentRows")) || [];
      if (this.hiddenContentRowList.length) {
        let rowInList = false;
        this.hiddenContentRowList.forEach((hiddenRow) => {
          if (hiddenRow.id === row.id) {
            hiddenRow.isHidden = true;
            rowInList = true;
          }
        });
        if (!rowInList) {
          this.hiddenContentRowList.push(row);
        }
        localStorage.setItem(
          "hiddenContentRows",
          JSON.stringify(this.hiddenContentRowList)
        );
      } else {
        this.hiddenContentRowList.push(row);
        localStorage.setItem(
          "hiddenContentRows",
          JSON.stringify(this.hiddenContentRowList)
        );
      }
    } catch (e) {
      console.log(e);
    }
  }

  hideContentRow(row: ContentRow) {
    row.isHidden = false;
    try {
      this.hiddenContentRowList =
        JSON.parse(localStorage.getItem("hiddenContentRows")) || [];
      if (this.hiddenContentRowList.length) {
        let rowInList = false;
        this.hiddenContentRowList.forEach((hiddenRow) => {
          if (hiddenRow.id === row.id) {
            hiddenRow.isHidden = false;
            rowInList = true;
          }
        });
        if (!rowInList) {
          this.hiddenContentRowList.push(row);
        }
        localStorage.setItem(
          "hiddenContentRows",
          JSON.stringify(this.hiddenContentRowList)
        );
      } else {
        this.hiddenContentRowList.push(row);
        localStorage.setItem(
          "hiddenContentRows",
          JSON.stringify(this.hiddenContentRowList)
        );
      }
    } catch (err) {
      console.log(err);
    }
  }
  /**
   * Method to delete row containing contentBlock
   * @param row ContentRow object
   */
  deleteRow(row: ContentRow, isRowDeleted: boolean = false) {
    if (this.selectedContentBlock) {
      this.commService.sendSelectedContentBlock(null);
    }
    const initialState = {
      msg: `Are you sure you want to delete this content${
        isRowDeleted ? " row" : ""
      }?`,
    };

    this.confirmationModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );

    this.confirmationModalRef.content.onclose.subscribe((toDelete: boolean) => {
      this.confirmationModalRef.hide();
      if (toDelete) {
        this.commService.setServerProcess(true);
        this.commonHttpService
          .deleteWithBodyWithHeaders(
            {
              uri: "/api/ContentRows",
              object: {
                id: row.id,
                playbookId: row.playbookId,
                pageTemplateId: this.pageTemplateId,
              },
            },
            {
              pageId: this.container.id,
              sectionId: this.parentSectionId,
              playbookId: this.playbookId,
              languageId: this.languageId,
              isdraftmode: this.container.isCurrentPageInDraftMode,
              isRowDeleted,
            }
          )
          .subscribe(
            (response: Container) => {
              this.isCopyPageExists();
              const ConatinerIndex = findIndex(
                this.container.containers,
                (eachContainers) => eachContainers.id === response.id
              );
              if (ConatinerIndex !== -1) {
                const rowIndex = findIndex(
                  response.contentColumns[0].contentRows,
                  (eachRow) => eachRow.id === row.id
                );
                if (rowIndex !== -1) {
                  if (response.contentColumns[0].contentRows.length === 1) {
                    this.container.containers[ConatinerIndex] = response;
                  } else {
                    this.container.containers[
                      ConatinerIndex
                    ].contentColumns[0].contentRows[rowIndex] =
                      response.contentColumns[0].contentRows[rowIndex];
                  }
                } else {
                  this.container.containers[
                    ConatinerIndex
                  ].contentColumns[0].contentRows =
                    response.contentColumns[0].contentRows;
                }
              } else {
                const TabconatinerIndex = findIndex(
                  this.container.containers,
                  (eachContainers) => eachContainers.id === this.parentSectionId
                );
                const rowIndexData = this.utilService.getTabsRowColumnId(
                  this.container.containers[TabconatinerIndex].contentColumns[0]
                    .contentRows,
                  this.tElement.c.contentRowId
                );
                if (rowIndexData.secondRowIndex != null) {
                  // tslint:disable-next-line: max-line-length
                  this.assignMovedContentTabs(
                    this.container.containers[TabconatinerIndex]
                      .contentColumns[0].contentRows[rowIndexData.firstRowIndex]
                      .contentColumns[rowIndexData.firstColumnIndex]
                      .contentRows[rowIndexData.secondRowIndex],
                    this.tElement.t.id,
                    response
                  );
                } else {
                  // tslint:disable-next-line: max-line-length
                  if (
                    !this.container.containers[TabconatinerIndex]
                      .contentColumns[0].contentRows[rowIndexData.firstRowIndex]
                      .contentColumns.length
                  ) {
                    // tslint:disable-next-line: max-line-length
                    this.assignMovedContentTabs(
                      this.container.containers[TabconatinerIndex]
                        .contentColumns[0].contentRows[
                        rowIndexData.firstRowIndex
                      ],
                      this.tElement.t.id,
                      response
                    );
                  } else {
                    const tabBlockIndex = this.utilService.getTabsBlockIndex(
                      this.tElement.t.tabsBlockId,
                      this.container.containers[TabconatinerIndex]
                        .contentColumns[0].contentRows[
                        rowIndexData.firstRowIndex
                      ].contentColumns
                    );
                    // tslint:disable-next-line: max-line-length
                    this.assignMovedContentTabs(
                      this.container.containers[TabconatinerIndex]
                        .contentColumns[0].contentRows[
                        rowIndexData.firstRowIndex
                      ].contentColumns[tabBlockIndex.columnIndex].contentRows[
                        tabBlockIndex.rowIndex
                      ],
                      this.tElement.t.id,
                      response
                    );
                  }
                }
              }
              this.commService.setServerProcess(false);
            },
            (error) => this.commService.setServerProcess(false)
          );
      }
    });
  }

  isCopyPageExists() {
    const profile = this.sessionStorageService.getLoggedInProfileDetail();
    this.commonHttpService
      .get({
        uri: `/api/Playbooks/IsCopyContentExists?userId=${profile.id}&playbookId=${this.playbookId}&pageTemplateId=${this.pageTemplateId}`,
      })
      .subscribe((copyContentData: CopyContentExists) => {
        this.commService.setCopyContentExists(copyContentData);
      });
  }
  /**
   * Method to handle settings wrapper
   * @param contentBlock ContentBlock object
   * @param event click event object
   */
  articleClick(contentBlock: ContentBlock, event) {
    if (event) {
      event.stopPropagation();
    }
    if (contentBlock.type === 1) {
      const menu = $(`#content-block-menu-${contentBlock.id}`);
      menu.css({
        width:
          $(`#contentblock-${contentBlock.id}`)
            .closest("article.content")
            .width() + "px",
      });
      menu.show();
    }
    this.commService.sendSelectedContentBlockId(contentBlock.id);
    this.commService.sendSelectedContentBox(false);
    if (
      this.selectedContentBlock &&
      this.selectedContentBlock.id !== contentBlock.id
    ) {
      this.commService.sendSelectedContentBlock(null);
    }
  }

  rowClick(row, event) {
    if (event) {
      event.stopPropagation();
    }
    this.showHideRowEditSelectionArea(null);
    this.commService.sendSelectedRowId(row.id);
    this.commService.sendSelectedContentBox(false);
  }

  /**
   * Method to handle add edit modal for contentBlock
   * @param contentBlock ContentBlock object
   */
  settingContentBlock(contBlock) {
    if (this.selectedContentBlock) {
      this.commService.sendSelectedContentBlock(null);
    }
    if (contBlock.type == 16 && (this.pageTemplateId || this.pageFrom)) {
      this.messageService.showInfoMessage(
        `Challenge blocks cannot be edited in ${
          this.pageTemplateId ? "Page" : "Playbook"
        } Template Editor.`
      );
    } else {
      this.commService.setAddEditContentBlock(contBlock.id);
    }
  }

  copyPlaybookContent(rowData, isRowCopied = false) {
    if (this.selectedContentBlock) {
      this.commService.sendSelectedContentBlock(null);
    }
    const profile = this.sessionStorageService.getLoggedInProfileDetail();
    this.commService.setServerProcess(true);
    this.commonHttpService
      .put({
        uri: `/api/Playbooks/CopyPlaybookContentBlock`,
        object: {
          playbookId: this.playbookId,
          profileId: profile.id,
          contentBlockId: !isRowCopied ? rowData.id : 0,
          contentType: isRowCopied ? ContentBlockType.CopyPaste : rowData.type,
          pageTemplateId: this.pageTemplateId,
          contentRowId: isRowCopied ? rowData.id : null,
        },
        message: {
          successMessage: "Content successfully copied to your clipboard.",
          errorMessage:
            "Something went wrong while copying content to your clipboard.",
        },
      })
      .subscribe(
        (contentCopied: boolean) => {
          this.commService.setCopyContentExists({
            contentType: isRowCopied
              ? ContentBlockType.CopyPaste
              : rowData.type,
            isCopyExist: contentCopied,
            rowCopied: isRowCopied,
          });
          this.commService.setServerProcess(false);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }
  onDrop(event, row) {
    const data = this.commService.getMovedContentData();
    const eventData =
      event.data.type !== ContentBlockType.MoveContent ? event.data : data;
    this.contentDropped(eventData, row);
  }

  settingAnimationBlock(contentBlock) {
    this.commService.sendSelectedContentBlock(contentBlock);
    setTimeout(() => {
      this.dragElement(document.getElementById("animation-menu"));
    }, 1000);
  }

  getContentTypeForIcon(type) {
    return (
      type == ContentBlockType.Text ||
      type == ContentBlockType.Image ||
      type == ContentBlockType.Audio ||
      type == ContentBlockType.Video
    );
  }

  getContentTypeForDialog(type) {
    return (
      type == ContentBlockType.Image ||
      type == ContentBlockType.Audio ||
      type == ContentBlockType.Video
    );
  }

  showAnimationMenu(rowData) {
    if (rowData) {
      this.selectedContentBlock = rowData;
      this.animationDirection = rowData.animationDirection || null;
      this.animationType = rowData.animationType || null;
      this.column.contentRows.map((row: ContentRow) => {
        if (row.contentBlock) {
          row.contentBlock.isAnimationBoxOpened = false;
        }
      });
      rowData.isAnimationBoxOpened = true;
      if (this.animationType) {
        const selectedAnimationData = this.animationList.filter(
          (animation) => animation.value === this.animationType
        )[0];
        this.changeAnimation(selectedAnimationData, true);
      } else {
        this.animationList.map((animation) => (animation.selected = false));
      }
    }
  }

  stopAnimationClose(event) {
    event.stopPropagation();
  }

  changeAnimation(selectedAnimation, fromFunc = false) {
    this.animationType = selectedAnimation.value;
    this.animationList.forEach((animation) => {
      if (animation.value === selectedAnimation.value) {
        animation.selected = true;
      } else {
        animation.selected = false;
      }
    });
    this.dropdownList = selectedAnimation.directions;
    if (!fromFunc) {
      this.animationDirection = selectedAnimation.directions[0].value;
      this.onAnimationSelect();
    }
  }

  onAnimationSelect() {
    this.column.contentRows.forEach((row: any) => {
      if (row.contentColumns.length) {
        row.contentColumns.forEach((column) => {
          this.contentColumnAnimation(column);
        });
      } else if (
        row.contentBlock &&
        row.contentBlock.id === this.selectedContentBlock.id
      ) {
        row.contentBlock.animationState = false;
        setTimeout(() => {
          row.contentBlock.animationState = true;
        }, 1);
      }
    });
  }

  contentColumnAnimation(column) {
    column.contentRows.forEach((row) => {
      if (row.contentColumns.length) {
        row.contentColumns.forEach((column) => {
          this.contentColumnAnimation(column);
        });
      } else if (
        row.contentBlock &&
        row.contentBlock.id === this.selectedContentBlock.id
      ) {
        row.contentBlock.animationState = false;
        setTimeout(() => {
          row.contentBlock.animationState = true;
        }, 1);
      }
    });
  }

  closeAnimationBox() {
    this.animationList.map((animation) => (animation.selected = false));
    this.animationType = null;
    this.animationDirection = null;
    this.column.contentRows.map((row: ContentRow) => {
      if (row.contentBlock) {
        row.contentBlock.isAnimationBoxOpened = false;
      }
    });
    this.commService.sendSelectedContentBlock(null);
  }

  saveAnimation() {
    const reqObj = {
      id: this.selectedContentBlock.id,
      playbookId: this.selectedContentBlock.playbookId,
      animationDirection: this.animationDirection,
      animationType: this.animationType,
      pageTemplateId: this.pageTemplateId,
    };
    this.commonHttpService
      .putWithHeaders(
        {
          uri: "/api/ContentBlocks/UpdateContentBlockAnimation",
          object: reqObj,
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe((res: ContentBlock) => {
        this.column.contentRows.forEach((row) => {
          if (row.contentBlock && row.contentBlock.id === res.id) {
            row.contentBlock.animationType = res.animationType || null;
            row.contentBlock.animationDirection =
              res.animationDirection || null;
          }
        });
        this.closeAnimationBox();
      });
  }

  deleteAnimation() {
    const reqObj = {
      id: this.selectedContentBlock.id,
      playbookId: this.selectedContentBlock.playbookId,
    };
    this.commonHttpService
      .deleteWithBody({
        uri: "/api/ContentBlocks/DeleteAnimation",
        object: reqObj,
      })
      .subscribe((res) => {
        this.column.contentRows.forEach((row) => {
          if (row.contentBlock.id === this.selectedContentBlock.id) {
            row.contentBlock.animationType = null;
            row.contentBlock.animationDirection = null;
          }
        });
        this.closeAnimationBox();
      });
  }

  dragElement(elmnt) {
    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (document.getElementById(elmnt.id)) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById(elmnt.id).onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  contentDropped(eventData, row) {
    const t = $(".bottom-hover,.top-hover,.left-hover,.right-hover").first();
    const id = this.utilService.getElementId(t);
    let currentTabData = null;
    if (
      t.parent(".tab-container").length ||
      t.parent(".dndDraggableDisabled").parent(".row").parent(".tab-container")
        .length ||
      t
        .parent(".col")
        .parent(".dndDraggableDisabled")
        .parent(".row")
        .parent(".tab-container").length
    ) {
      this.currentTabId = t.parents(".tabsContent").attr("id");
      currentTabData = this.commService.getCurrentTabData(this.currentTabId);
    }
    if (id) {
      const position = this.utilService.getCorrectPosition(t);
      const contType = eventData.type;
      const movedData = this.commService.getMovedContentData();
      if (
        !this.utilService.checkTypes(
          contType,
          currentTabData,
          movedData,
          position
        )
      ) {
        return;
      }
      if (this.currentTabId || position === "left" || position === "right") {
        const pastedContent = this.commService.getCopyContentExists();
        if (
          pastedContent.isCopyExist &&
          !this.utilService.pasteCheckTypes(contType, pastedContent)
        ) {
          return;
        }
      }
      if (!row || t.hasClass("norow")) {
        this.nowRowAddTop(eventData, id);
      } else {
        this.getAllData(eventData, row, t, id, currentTabData, movedData);
      }
    }
  }
  nowRowAddTop(eventData, id) {
    const movedContentBlockId = eventData.id || null;
    const movedData = this.commService.getMovedContentData();
    this.utilService.clearAllBorderClasses();
    this.commService.setServerProcess(true);

    this.commonHttpService
      .postWithHeaders(
        {
          uri: `/api/ContentRows`,
          object: {
            playbookId: this.playbookId,
            contentColumnId: id,
            movedContentBlockId,
            ...(movedData &&
              movedData.isRowMoving && {
                movedContentRowId: movedContentBlockId,
              }),
            type: eventData.type,
            order: 0,
            pageTemplateId: this.pageTemplateId,
          },
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          movedSectionId: eventData.sectionId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: ContentRow) => {
          if (this.hideContent) {
            response.showHideStrng = "show";
          }
          this.column.contentRows.push(response);
          this.normalizeNewTextRowContent(response);
          if (movedContentBlockId) {
            this.deleteContentRow(eventData);
          }
          this.commService.setServerProcess(false);
          this.commService.setUpdateLanguagesAfterPasteContent();
        },
        (error) => this.commService.setServerProcess(false)
      );
  }
  getAllData(eventData, row, t, id, currentTabData, movedData) {
    let rowColumnData = {
      rowData: row,
      columnData: this.column,
    };

    const position = this.utilService.getCorrectPosition(t);
    const contType = eventData.type;
    const videoblock = eventData.videoblock;
    const pastedContent = this.commService.getCopyContentExists();
    const currentConatiner = currentTabData
      ? currentTabData.container
      : this.utilService.getCurrentSectionData(
          this.commService.getCurrentPageData,
          this.parentSectionId
        );

    if (row.id != id) {
      if (position === "top" || position === "bottom") {
        rowColumnData = currentTabData
          ? this.utilService.getColumnRowData(currentTabData.container, id)
          : this.utilService.getColumnRowData(currentConatiner, id);
      } else if (position === "left" || position === "right") {
        rowColumnData = currentTabData
          ? this.utilService.getColumnRowData(currentTabData.container, id)
          : this.utilService.getLeftRightColumnRowData(currentConatiner, id);
        if (!(rowColumnData.columnData && rowColumnData.rowData)) {
          rowColumnData = this.utilService.getLeftRightColumnRowData(
            currentConatiner,
            id
          );
        }
      }
    }

    const movedContentBlockId = eventData.id || null;
    let apiObjData;
    let apiTopBottom;
    if (t.length) {
      switch (position) {
        case "top":
          if (
            !this.utilService.checkTopBottom(
              contType,
              rowColumnData,
              movedData,
              pastedContent
            )
          ) {
            return;
          }
          apiTopBottom =
            this.playbookAddRowColumnService.addRowAndBlockToColumn(
              rowColumnData.columnData,
              rowColumnData.rowData,
              id,
              contType,
              position,
              this.commService.getCurrentPageData,
              movedContentBlockId,
              movedContentBlockId,
              this.playbookId,
              this.pageTemplateId,
              movedData
            );
          this.addTopBottom(
            apiTopBottom,
            rowColumnData.columnData,
            eventData,
            movedContentBlockId
          );
          this.utilService.clearAllBorderClasses();
          break;
        case "bottom":
          if (
            !this.utilService.checkTopBottom(
              contType,
              rowColumnData,
              movedData,
              pastedContent
            )
          ) {
            return;
          }
          apiTopBottom =
            this.playbookAddRowColumnService.addRowAndBlockToColumn(
              rowColumnData.columnData,
              rowColumnData.rowData,
              id,
              contType,
              position,
              this.commService.getCurrentPageData,
              movedContentBlockId,
              movedContentBlockId,
              this.playbookId,
              this.pageTemplateId,
              movedData
            );
          this.addTopBottom(
            apiTopBottom,
            rowColumnData.columnData,
            eventData,
            movedContentBlockId
          );
          this.utilService.clearAllBorderClasses();
          break;
        case "left":
          const tabHeaders = {
            pageId: this.activatedRoute.snapshot.params.pageId,
            sectionId: this.activatedRoute.snapshot.params.sectionId,
          };
          apiObjData =
            this.playbookAddRowColumnService.addColumnRowAndBlockToRow(
              currentConatiner,
              rowColumnData.rowData,
              rowColumnData.columnData,
              position,
              contType,
              this.tElement,
              tabHeaders,
              videoblock,
              movedContentBlockId,
              this.pageTemplateId
            );
          if (apiObjData.api) {
            this.addRowColumnApi(apiObjData, eventData, movedContentBlockId);
          } else {
            this.addRowMoveRowColumnApi(
              apiObjData,
              eventData,
              movedContentBlockId
            );
          }
          this.utilService.clearAllBorderClasses();
          break;
        case "right":
          const tabHeadersRight = {
            pageId: this.activatedRoute.snapshot.params.pageId,
            sectionId: this.activatedRoute.snapshot.params.sectionId,
          };
          apiObjData =
            this.playbookAddRowColumnService.addColumnRowAndBlockToRow(
              currentConatiner,
              rowColumnData.rowData,
              rowColumnData.columnData,
              position,
              contType,
              this.tElement,
              tabHeadersRight,
              videoblock,
              movedContentBlockId,
              this.pageTemplateId
            );
          if (apiObjData.api) {
            this.addRowColumnApi(apiObjData, eventData, movedContentBlockId);
          } else {
            this.addRowMoveRowColumnApi(
              apiObjData,
              eventData,
              movedContentBlockId
            );
          }
          this.utilService.clearAllBorderClasses();
          break;
        default:
          this.utilService.clearAllBorderClasses();
      }
    }
    setTimeout(() => this.commService.setUpdateLanguagesAfterPasteContent());
  }

  evenRowColumns(row) {
    this.commService.setServerProcess(true);
    this.commonHttpService
      .postWithHeaders(
        {
          uri: `/api/ContentRows/SetColumnsWidth`,
          object: {
            playbookId: this.playbookId,
            contentRowId: row.id,
            pageTemplateId: this.pageTemplateId,
          },
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: ContentRow) => {
          const rowIndex = findIndex(
            this.column.contentRows,
            (eachRowData) => eachRowData.id === response.id
          );
          this.column.contentRows[rowIndex] = response;
          this.commService.setServerProcess(false);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }
  addRowMoveRowColumnApi(apiObj, eventData, movedContentBlockId) {
    this.commService.setServerProcess(true);
    this.commonHttpService
      .postWithHeaders(
        {
          uri: apiObj.uri,
          object: apiObj.object,
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          movedSectionId: eventData.sectionId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: Container) => {
          if (this.currentTabId) {
            const currentTabData = this.commService.getCurrentTabData(
              this.currentTabId
            );
            this.getAddedTabColumnData(
              this.container.containers,
              response.id,
              this.parentSectionId,
              currentTabData.tabsBlockId,
              apiObj.object.containerId,
              response,
              false
            );
            this.currentTabId = null;
          } else {
            const currentPageData: Container =
              this.commService.getCurrentPageData;
            const containerIndex = this.utilService.getAddedColumnData(
              currentPageData.containers,
              response.id,
              this.parentSectionId
            );
            if (containerIndex.sectionIndex !== -1) {
              this.container.containers[
                containerIndex.sectionIndex
              ].contentColumns[0] = response.contentColumns[0];
            } else {
              this.messageService.showErrorMessage(
                "some went wrong please refresh"
              );
            }
          }
          if (movedContentBlockId) {
            if (apiObj.object.contentRowId === eventData.rowId) {
              eventData.rowId = this.utilService.getRowIdFromContentBlockId(
                response.contentColumns[0],
                eventData.rowId,
                eventData.id
              );
            }
            this.deleteContentRow(eventData);
          }
          this.commService.setServerProcess(false);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }
  addRowColumnApi(apiObj, eventData, movedContentBlockId) {
    this.commService.setServerProcess(true);
    this.commonHttpService
      .postWithHeaders(
        {
          uri: apiObj.uri,
          object: apiObj.object,
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          movedSectionId: eventData.sectionId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: ContentRow) => {
          if (this.currentTabId) {
            const currentTabData = this.commService.getCurrentTabData(
              this.currentTabId
            );
            this.getAddedTabColumnData(
              this.container.containers,
              response.id,
              this.parentSectionId,
              currentTabData.tabsBlockId,
              apiObj.object.containerId,
              response,
              true
            );
            this.currentTabId = null;
          } else {
            const currentPageData = this.commService.getCurrentPageData;
            const containerIndex = this.utilService.getAddedColumnData(
              currentPageData.containers,
              response.id,
              this.parentSectionId
            );
            if (apiObj.api) {
              this.container.containers[
                containerIndex.sectionIndex
              ].contentColumns[0].contentRows[containerIndex.columnIndex] =
                response;
            }
          }
          if (movedContentBlockId) {
            this.deleteContentRow(eventData);
          }
          this.commService.setServerProcess(false);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }

  addTopBottom(apiObj, column, eventData, movedContentBlockId) {
    this.commService.setServerProcess(true);
    this.commonHttpService
      .postWithHeaders(
        {
          uri: apiObj.uri,
          object: apiObj.object,
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          movedSectionId: eventData.sectionId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: ContentRow) => {
          if (column.contentRows == null) {
            column.contentRows = [];
          } else {
            each(column.contentRows, (eachContentRow) => {
              if (eachContentRow.order >= response["order"]) {
                ++eachContentRow.order;
              }
            });
          }
          column.contentRows.push(response);
          this.normalizeNewTextRowContent(response);
          if (movedContentBlockId) {
            this.deleteContentRow(eventData);
          }
          this.commService.setServerProcess(false);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }
  deleteContentRow(eventData) {
    this.commonHttpService
      .deleteWithBodyWithHeaders(
        {
          uri: `/api/ContentRows`,
          object: {
            playbookId: +this.playbookId,
            id: eventData.rowId,
            pageTemplateId: this.pageTemplateId,
          },
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          isContentMoved: true,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: Container) => {
          this.isCopyPageExists();
          const ConatinerIndex = findIndex(
            this.container.containers,
            (eachContainers) => eachContainers.id === response.id
          );
          if (ConatinerIndex !== -1) {
            const rowIndex = findIndex(
              response.contentColumns[0].contentRows,
              (eachRow) => eachRow.id === eventData.rowId
            );
            if (rowIndex !== -1) {
              if (response.contentColumns[0].contentRows.length === 1) {
                this.container.containers[ConatinerIndex] = response;
              } else {
                this.container.containers[
                  ConatinerIndex
                ].contentColumns[0].contentRows[rowIndex] =
                  response.contentColumns[0].contentRows[rowIndex];
              }
            } else {
              this.container.containers[
                ConatinerIndex
              ].contentColumns[0].contentRows =
                response.contentColumns[0].contentRows;
            }
          } else {
            const TabconatinerIndex = findIndex(
              this.container.containers,
              (eachContainers) => eachContainers.id === eventData.sectionId
            );
            const rowIndexData = this.utilService.getTabsRowColumnId(
              this.container.containers[TabconatinerIndex].contentColumns[0]
                .contentRows,
              eventData.tElement.c.contentRowId
            );
            if (rowIndexData.secondRowIndex != null) {
              // tslint:disable-next-line: max-line-length
              this.assignMovedContentTabs(
                this.container.containers[TabconatinerIndex].contentColumns[0]
                  .contentRows[rowIndexData.firstRowIndex].contentColumns[
                  rowIndexData.firstColumnIndex
                ].contentRows[rowIndexData.secondRowIndex],
                eventData.tElement.t.id,
                response
              );
            } else {
              // tslint:disable-next-line: max-line-length
              if (
                !this.container.containers[TabconatinerIndex].contentColumns[0]
                  .contentRows[rowIndexData.firstRowIndex].contentColumns.length
              ) {
                // tslint:disable-next-line: max-line-length
                this.assignMovedContentTabs(
                  this.container.containers[TabconatinerIndex].contentColumns[0]
                    .contentRows[rowIndexData.firstRowIndex],
                  eventData.tElement.t.id,
                  response
                );
              } else {
                const tabBlockIndex = this.utilService.getTabsBlockIndex(
                  eventData.tElement.t.tabsBlockId,
                  this.container.containers[TabconatinerIndex].contentColumns[0]
                    .contentRows[rowIndexData.firstRowIndex].contentColumns
                );
                // tslint:disable-next-line: max-line-length
                this.assignMovedContentTabs(
                  this.container.containers[TabconatinerIndex].contentColumns[0]
                    .contentRows[rowIndexData.firstRowIndex].contentColumns[
                    tabBlockIndex.columnIndex
                  ].contentRows[tabBlockIndex.rowIndex],
                  eventData.tElement.t.id,
                  response
                );
              }
            }
          }
          this.commService.setServerProcess(false);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }
  assignMovedContentTabs(
    tabsCurrentRowData: ContentRow,
    tabElementId: number,
    deletedContainerResponse: Container
  ) {
    if (!tabsCurrentRowData.contentColumns.length) {
      const tabElementIndex = findIndex(
        tabsCurrentRowData.contentBlock.tabsBlock.elements,
        (eachTabsElement) => eachTabsElement.id === tabElementId
      );
      if (
        tabsCurrentRowData.contentBlock.tabsBlock.elements[tabElementIndex]
          .container.id === deletedContainerResponse.id
      ) {
        tabsCurrentRowData.contentBlock.tabsBlock.elements[
          tabElementIndex
        ].container.contentColumns[0] =
          deletedContainerResponse.contentColumns[0];
      }
    }
  }
  getAddedTabColumnData(
    containerData: Array<Container>,
    columnId: number,
    sectionId: number,
    tabsBlockId: number,
    containerId: number,
    responseData: any,
    isApplyCurrentColumn: boolean
  ) {
    const sectionIndex = findIndex(
      containerData,
      (eachContainter) => eachContainter.id === sectionId
    );
    let tabsRowIndex;
    if (sectionIndex !== -1) {
      each(
        containerData[sectionIndex].contentColumns[0].contentRows,
        (eachContentRow, index) => {
          if (!tabsRowIndex) {
            if (
              eachContentRow.contentBlock &&
              eachContentRow.contentBlock.tabsBlock &&
              eachContentRow.contentBlock.tabsBlock.id === tabsBlockId
            ) {
              tabsRowIndex = index;
              this.assignTabsData(
                eachContentRow,
                containerId,
                responseData,
                isApplyCurrentColumn
              );
            } else {
              each(eachContentRow.contentColumns, (eachContentColumnInner) => {
                each(
                  eachContentColumnInner.contentRows,
                  (eachContentRowInner) => {
                    if (
                      eachContentRowInner.contentBlock &&
                      eachContentRowInner.contentBlock.tabsBlock &&
                      eachContentRowInner.contentBlock.tabsBlock.id ===
                        tabsBlockId
                    ) {
                      tabsRowIndex = index;
                      this.assignTabsData(
                        eachContentRowInner,
                        containerId,
                        responseData,
                        isApplyCurrentColumn
                      );
                    }
                  }
                );
              });
            }
          }
        }
      );
    }
  }

  // assign Tabs data from current found inner column and row index
  assignTabsData(
    eachContentRow: ContentRow,
    containerId: number,
    responseData: any,
    isApplyCurrentColumn: boolean
  ) {
    each(eachContentRow.contentBlock.tabsBlock.elements, (eachTabElement) => {
      if (eachTabElement.container.id === containerId) {
        if (isApplyCurrentColumn) {
          const rowIndex = findIndex(
            eachTabElement.container.contentColumns[0].contentRows,
            (eachContentRows) => eachContentRows.id === responseData.id
          );
          eachTabElement.container.contentColumns[0].contentRows[rowIndex] =
            responseData;
        } else {
          eachTabElement.container.contentColumns[0] =
            responseData.contentColumns[0];
        }
      }
    });
  }
  // for move
  onDragStart(event, rowData, containedId) {
    this.isRowMoving = false;
    this.commService.setMovedContentData({
      type: ContentBlockType.MoveContent,
      id: rowData.contentBlock.id,
      rowId: rowData.contentBlock.contentRowId,
      containerId: containedId,
      sectionId: this.parentSectionId,
      tElement: this.tElement,
    });
  }

  // for move
  onDragRowStart(event, rowData, containedId) {
    this.isRowMoving = true;
    this.commService.setMovedContentData({
      type: ContentBlockType.MoveContent,
      id: rowData.id,
      rowId: rowData.id,
      containerId: containedId,
      sectionId: this.parentSectionId,
      tElement: this.tElement,
      isRowMoving: this.isRowMoving,
    });
  }

  onDragEnd(e) {
    this.isRowMoving = false;
    this.commService.clearMovedContentData();
  }

  onDrag(e, isRowCopied = false) {
    const ui = {
      offset: {
        top: e.y,
        left: e.x,
      },
    };
    const t = $(e.target);
    const d = $(".dndDragover");
    if (!d.length) {
      this.utilService.clearAllBorderClasses();
    }
    if (d.length > 1) {
      d.first().removeClass("dndDragover");
    }
    if (d.hasClass("norow")) {
      this.utilService.applyBorderClass(d, "top-hover");
    } else {
      if (d.length) {
        this.utilService.detectAndAddHoverClass(d, ui, t);
      }
    }
  }

  ngOnDestroy() {
    if (this.updateSubsciption) {
      this.updateSubsciption.unsubscribe();
    }
    if (this.rowBoxSubsciption) {
      this.rowBoxSubsciption.unsubscribe();
    }
    if (this.animationSubs) {
      this.animationSubs.unsubscribe();
    }
  }
  private initResizableColumns(evt) {
    this.contentColumns = orderBy(
      this.row1.contentColumns,
      (column: ContentColumn) => {
        return column.order;
      }
    );
    this.renderer.listen("body", "mousemove", (event) => {
      if (this.pressed) {
        this.startX = evt.x;

        if (this.contentColumns && this.contentColumns.length > 1) {
          this.startWidth = $(this.start).parent().width();

          const newWidth = this.startWidth + (event.x - this.startX);
          const index = $(this.start).parent().index();
          this.currIndex = index;

          // get first column width
          const firstColumnWidthPercentage: number =
            this.contentColumns[index].columnWidth;
          // get second column width
          const secondColumnWidthPercentage: number =
            this.contentColumns[index + 1].columnWidth;

          const totalPercentage: number =
            firstColumnWidthPercentage + secondColumnWidthPercentage;
          // calculate the change in percentage.
          const changeInPercentage = this.roundOffPercentage(
            (newWidth * firstColumnWidthPercentage) / this.startWidth
          );

          const sendColumneNewWidth: number =
            totalPercentage - changeInPercentage;
          if (
            changeInPercentage >= 10 &&
            changeInPercentage <= totalPercentage - 10
          ) {
            this.contentColumns[index].columnWidth = changeInPercentage;
            this.contentColumns[index + 1].columnWidth = sendColumneNewWidth;
          }
        }
      }
    });
    this.renderer.listen("body", "mouseup", (event) => {
      if (
        this.pressed &&
        this.contentColumns[this.currIndex] &&
        this.contentColumns[this.currIndex + 1]
      ) {
        this.pressed = false;
        this.commService.setServerProcess(true);
        this.commonHttpService
          .postWithHeaders(
            {
              uri: "/api/ContentRows/ResizeColumns",
              object: {
                playbookId: this.playbookId,
                contentRowId: this.row1.id,
                pageTemplateId: this.pageTemplateId,
                columnWidths: [
                  {
                    id: this.contentColumns[this.currIndex].id,
                    width: this.contentColumns[this.currIndex].columnWidth,
                  },
                  {
                    id: this.contentColumns[this.currIndex + 1].id,
                    width: this.contentColumns[this.currIndex + 1].columnWidth,
                  },
                ],
              },
            },
            {
              pageId: this.container.id,
              sectionId: this.parentSectionId,
              playbookId: this.playbookId,
              languageId: this.languageId,
              isdraftmode: this.container.isCurrentPageInDraftMode,
            }
          )
          .subscribe(
            (response: ContentRow) => {
              this.commService.setServerProcess(false);
            },
            (error) => this.commService.setServerProcess(false)
          );
      }
    });
  }
  onMouseDown(event: any) {
    this.resizableColumnOption = true;
    if (this.resizableColumnOption) {
      this.start = event.target;
      this.pressed = true;
      this.initResizableColumns(event);
    }
  }

  sideArrowResize(isleft: boolean, columnId: number) {
    this.contentColumns = orderBy(
      this.row1.contentColumns,
      (column: ContentColumn) => {
        return column.order;
      }
    );
    if (this.contentColumns && this.contentColumns.length > 1) {
      const columnIndex = findIndex(
        this.contentColumns,
        (eachContentColumns: ContentColumn) =>
          eachContentColumns.id === columnId
      );
      const index = this.contentColumns[columnIndex].order;
      isleft ? this.leftSideResize(index) : this.rightSideResize(index);
    }
  }

  leftSideResize(index: number) {
    const firstColumnWidthPercentage: number =
      +this.contentColumns[index - 1].columnWidth;
    // get second column width
    const secondColumnWidthPercentage: number =
      +this.contentColumns[index].columnWidth;
    if (firstColumnWidthPercentage >= 15) {
      this.resizeApiCall(index - 1, {
        first: firstColumnWidthPercentage - 5,
        second: secondColumnWidthPercentage + 5,
      });
    }
  }

  rightSideResize(index: number) {
    // get second column width
    const secondColumnWidthPercentage: number =
      +this.contentColumns[index + 1].columnWidth;
    const firstColumnWidthPercentage: number =
      +this.contentColumns[index].columnWidth;
    if (secondColumnWidthPercentage >= 15) {
      this.resizeApiCall(index, {
        first: firstColumnWidthPercentage + 5,
        second: secondColumnWidthPercentage - 5,
      });
    }
  }

  resizeApiCall(index, resizeWidth) {
    this.commService.setServerProcess(true);
    this.commonHttpService
      .postWithHeaders(
        {
          uri: "/api/ContentRows/ResizeColumns",
          object: {
            playbookId: this.playbookId,
            contentRowId: this.row1.id,
            pageTemplateId: this.pageTemplateId,
            columnWidths: [
              {
                id: this.contentColumns[index].id,
                width: resizeWidth.first,
              },
              {
                id: this.contentColumns[index + 1].id,
                width: resizeWidth.second,
              },
            ],
          },
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (response: ContentRow) => {
          this.contentColumns[index].columnWidth = resizeWidth.first;
          this.contentColumns[index + 1].columnWidth = resizeWidth.second;
          this.commService.setServerProcess(false);
          this.unsubscribeModelsSub();
        },
        (error) => {
          this.commService.setServerProcess(false);
          this.unsubscribeModelsSub();
        }
      );
  }

  unsubscribeModelsSub() {
    this.modalSubscription.forEach((sub) => {
      sub.unsubscribe();
    });
    this.modalSubscription = [];
  }

  roundOffPercentage(numToRound) {
    return parseInt(numToRound, 10);
  }

  onDragover(e: DragEvent) {
    if (this.isFireFox || this.isEdge) {
      const ui = {
        offset: {
          top: e.y,
          left: e.x,
        },
      };
      const t = $(e.target);
      const d = $(".dndDragover");
      if (e.x && e.y) {
        if (d.hasClass("norow")) {
          this.utilService.applyBorderClass(d, "top-hover");
        } else {
          if (d.length) {
            this.utilService.detectAndAddHoverClass(d, ui, t, this.level);
          }
        }
      }
    }
  }

  showHideRowEditSelectionArea(isShowEditRowWrapperGrey: number) {
    this.isShowEditRowWrapperGrey = isShowEditRowWrapperGrey;
  }
}
